import * as React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Warning } from '../../Icons';
import styles from './emergency-alert-create.module.css';

const EmergencyAlertCreateBubble: React.FC = () => {
    const { t } = useTranslation(['core']);

    return (
        <Link to="/communications/alerts/create" className={styles.EmergencyAlertButton}>
            <Warning aspect="1.25rem" />
            <p>{t('core:emergencyAlertCreateBubble.title')}</p>
        </Link>
    );
};

export default EmergencyAlertCreateBubble;
